/*let optionsAndQuestion1 = {
  questionTitle: "How was the Food",
  optionsSelected: [
    {
      optionTitle: "Excellent",
      pressed: true,
    },
    {
      optionTitle: "Good",
      pressed: false,
    },
    {
      optionTitle: "ok-ok",
      pressed: false,
    },
    {
      optionTitle: "bad",
      pressed: false,
    },
  ],
};

let data1 = [
  {
    data: {
      simpleQuestions: [
        { question: "Name:", answer: "name1", _id: "66fad2dc8f671e477d97a4b9" },
        {
          question: "Email/Phone",
          answer: "email@gmail.com",
          _id: "66fad2dc8f671e477d97a4ba",
        },
        {
          question: "remark",
          answer: "hello world",
          _id: "66fad2dc8f671e477d97a4bb",
        },
      ],
      optionQuestions: [
        {
          question: "How was the Food",
          answer: "Excellent",
          _id: "66fad2dc8f671e477d97a4bc",
        },
        {
          question: "How was the Service",
          answer: "Excellent",
          _id: "66fad2dc8f671e477d97a4bd",
        },
        {
          question: "how is the cleanliness / hygiene ",
          answer: "Good",
          _id: "66fad2dc8f671e477d97a4be",
        },
        {
          question: "How is the Ambience",
          answer: "Good",
          _id: "66fad2dc8f671e477d97a4bf",
        },
      ],
      checkQuestions: [],
    },
    _id: "66fad2dc8f671e477d97a4b8",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 5,
    createdAt: "2024-09-30T16:33:32.160Z",
    updatedAt: "2024-09-30T16:33:32.160Z",
    __v: 0,
  },
  {
    data: {
      simpleQuestions: [
        { question: "Name:", answer: "local", _id: "66fad2f78f671e477d97a4c2" },
        {
          question: "Email/Phone",
          answer: "email@gmail.com",
          _id: "66fad2f78f671e477d97a4c3",
        },
        {
          question: "remark",
          answer: "bad review",
          _id: "66fad2f78f671e477d97a4c4",
        },
      ],
      optionQuestions: [
        {
          question: "How was the Food",
          answer: "ok-ok",
          _id: "66fad2f78f671e477d97a4c5",
        },
        {
          question: "How was the Service",
          answer: "Bad",
          _id: "66fad2f78f671e477d97a4c6",
        },
        {
          question: "How is the Ambience",
          answer: "Bad",
          _id: "66fad2f78f671e477d97a4c7",
        },
      ],
      checkQuestions: [],
    },
    _id: "66fad2f78f671e477d97a4c1",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 1,
    createdAt: "2024-09-30T16:33:59.740Z",
    updatedAt: "2024-09-30T16:33:59.740Z",
    __v: 0,
  },

  {
    data: {
      simpleQuestions: [
        {
          question: "Name:",
          answer: "krish 2",
          _id: "66fd35b4ac62cb323655906b",
        },
        {
          question: "Email/Phone",
          answer: "email@gmail.com",
          _id: "66fd35b4ac62cb323655906c",
        },
      ],
      optionQuestions: [
        {
          question: "How was the Food",
          answer: "Bad",
          _id: "66fd35b4ac62cb323655906d",
        },
        {
          question: "How was the Service",
          answer: "Bad",
          _id: "66fd35b4ac62cb323655906e",
        },
        {
          question: "how is the cleanliness / hygiene ",
          answer: "Bad",
          _id: "66fd35b4ac62cb323655906f",
        },
        {
          question: "How is the Ambience",
          answer: "Bad",
          _id: "66fd35b4ac62cb3236559070",
        },
      ],
      checkQuestions: [],
    },
    _id: "66fd35b4ac62cb323655906a",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 1,
    createdAt: "2024-10-02T11:59:48.368Z",
    updatedAt: "2024-10-02T11:59:48.368Z",
    __v: 0,
  },

  {
    data: {
      simpleQuestions: [
        {
          question: "Name:",
          answer: "Aditya",
          _id: "6700e923d8c3cfdf798e1304",
        },
        {
          question: "Email/Phone",
          answer: "Abesoya11@gmail.com",
          _id: "6700e923d8c3cfdf798e1305",
        },
        {
          question: "remark",
          answer: "A very good experience ",
          _id: "6700e923d8c3cfdf798e1306",
        },
      ],
      optionQuestions: [
        {
          question: "How was the Food",
          answer: "Good",
          _id: "6700e923d8c3cfdf798e1307",
        },
        {
          question: "How was the Service",
          answer: "Good",
          _id: "6700e923d8c3cfdf798e1308",
        },
        {
          question: "how is the cleanliness / hygiene ",
          answer: "Excellent",
          _id: "6700e923d8c3cfdf798e1309",
        },
        {
          question: "How is the Ambience",
          answer: "Excellent",
          _id: "6700e923d8c3cfdf798e130a",
        },
      ],
      checkQuestions: [],
    },
    _id: "6700e923d8c3cfdf798e1303",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 5,
    createdAt: "2024-10-05T07:22:11.207Z",
    updatedAt: "2024-10-05T07:22:11.207Z",
    __v: 0,
  },
];

*/

export default function optionBasedFilter(data, optionsAndQuestion) {
  // console.log(data);
  // console.log(optionsAndQuestion);
  // step 1 first we store all options marked as true in an array

  let selectedOptionsArray = [];
  optionsAndQuestion.optionsSelected.forEach((item) => {
    if (item.pressed) selectedOptionsArray.push(item.optionTitle);
  });
  // console.log(selectedOptionsArray);

  //step2 iterate through all qustions and

  //now i have to iterate through out the data to check for specific questions

  let newData = data?.filter((object) => {
    let ifMatch = false;
    //above looping at feedback leve
    //below looping inside a feedback at question level
    object.data.optionQuestions.forEach((qa) => {
      // console.log(qa.answer);

      if (qa.title == optionsAndQuestion.questionTitle) {
        //now the question of feedback matches our desired question
        let answerInFeedback = qa.answer;
        //step now we iterate optionsAndQuestion object we receive as input
        // if options is pressed and it matches with answer of that question then we

        selectedOptionsArray.forEach((ans) => {
          if (ans == answerInFeedback) {
            // console.log("we have matching answer");
            ifMatch = true;
          }
        });
      }
    });
    if (ifMatch) {
      return true;
    }
  });
  //   console.log("result from this filteration");
  //   console.log(newData);
  return newData;
}
